// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export class Companie
{
  public id: string;
  public denumire: string;
  public type: string;
  public cif: string;
  public regCom: string;
  public vat: string;
  public country: string;
  public localitate: string;
  public codPostal: string;
  public adresa: string;
  public banca: string;
  public contBancar: string;
  public telefon: string;
  public reprezentant: string;
  public reprezentantid: string;
  public companieid: string;
  public stare: string;
  public stareafisare: string;
  public companieSelectata: boolean;
  public fisierCUI: string;
  public fisierCertificatFiscal: string;
  public fisierImputernicire: string;
  public fisierAprobareAdministratorJudiciar: string;
  public fisierAcordCompensareCuNerezidenti: string;
  public status: string;

  public documentCUI: File;
  public documentCertificatFiscal: File;
  public documentImputernicire: File;
  public documentAprobareAdministratorJudiciar: File;
  public documentAcordCompensareCuNerezidenti: File;

}

